import { TripType } from '../TripTypePicker';
import { CabinClass } from '@components/CabinPicker';

export const defaultData = {
    tripType: TripType.Oneway,
    fromCity: '',
    fromCityCode: '',
    toCity: '',
    toCityCode: '',
    fromDate: '',
    retDate: '',
    numAdult: 1,
    numChild: 0,
    cabinPref: CabinClass.Economy,
};
